<div class="social-actions-wrapper">
  <div class="social-networks" *ngIf="isHome === false" (click)="toggleShareModal()">
    <img class="pointer" width="18" height="18" [alt]="'SHARE' | translate" src="assets/img/share.svg">
    <span>{{ 'SOCIAL_SHARE.SHARE' | translate }}</span>
  </div>
  <div *ngIf="isHome === true" class="home-share">
    <div class="social-button pointer" [ngClass]="listView" (click)="toggleShareModal()" [title]="'SHARE' | translate"><img [ngClass]="listView" src="assets/icons/share.svg"></div>
  </div>
  <div class="user-overlay" *ngIf="isShareModalDisplayed" (click)="toggleShareModal()"></div>
  <div class="share-modal-wrapper" [ngClass]="listView" *ngIf="isShareModalDisplayed">
    <div class="share-modal">
      <div class="sb-wrapper pointer" *ngIf="detailsService.getPropertyByKey('social.share.facebook', true)" shareButton="facebook">
        <share-button type="facebook" (sendShareDatalayerEvent)="sendShareDatalayerEvent($event)" url="{{getUrl()}}" text="{{obtainDescription()}}">
        </share-button>
      </div>
      <div class="sb-wrapper pointer" *ngIf="detailsService.getPropertyByKey('social.share.twitter', true)" shareButton="twitter">
        <share-button type="twitter" (sendShareDatalayerEvent)="sendShareDatalayerEvent($event)" url="{{getUrl()}}" text="{{obtainDescription()}}" hashtags="{{getTags()}}">
        </share-button>
      </div>
      <div class="sb-wrapper pointer" *ngIf="detailsService.getPropertyByKey('social.share.pinterest', true)" shareButton="pinterest">
        <share-button type="pinterest" (sendShareDatalayerEvent)="sendShareDatalayerEvent($event)" url="{{getUrl()}}" text="{{obtainDescription()}}">
        </share-button>
      </div>
      <div class="sb-wrapper pointer" *ngIf="detailsService.getPropertyByKey('social.share.linkedIn', true)" shareButton="linkedIn">
        <share-button type="linkedin" (sendShareDatalayerEvent)="sendShareDatalayerEvent($event)" url="{{getUrl()}}" text="{{obtainDescription()}}">
        </share-button>
      </div>
      <div class="sb-wrapper pointer" *ngIf="detailsService.getPropertyByKey('social.share.whatsApp', true)" shareButton="whatsApp">
        <share-button type="whatsapp" (sendShareDatalayerEvent)="sendShareDatalayerEvent($event)" url="{{getUrl()}}" text="{{obtainDescription()}}">
        </share-button>
      </div>
      <div class="sb-wrapper pointer" *ngIf="detailsService.getPropertyByKey('social.share.telegram', true)" shareButton="telegram">
        <share-button type="telegram" (sendShareDatalayerEvent)="sendShareDatalayerEvent($event)" url="{{getUrl()}}" text="{{obtainDescription()}}">
        </share-button>
      </div>
      <div class="sb-wrapper pointer" *ngIf="detailsService.getPropertyByKey('social.share.instagram', true)" shareButton="instagram">
        <share-button type="instagram" (sendShareDatalayerEvent)="sendShareDatalayerEvent($event)" url="{{getUrl()}}" text="{{obtainDescription()}}">
        </share-button>
      </div>
      <div class="sb-wrapper pointer" *ngIf="detailsService.getPropertyByKey('social.share.tiktok', true)" shareButton="tiktok">
        <share-button type="tiktok" (sendShareDatalayerEvent)="sendShareDatalayerEvent($event)" url="{{getUrl()}}" text="{{obtainDescription()}}">
        </share-button>
      </div>
      <div class="sb-wrapper pointer" *ngIf="detailsService.getPropertyByKey('social.share.youtube', true)" shareButton="youtube">
        <share-button type="youtube" (sendShareDatalayerEvent)="sendShareDatalayerEvent($event)" url="{{getUrl()}}" text="{{obtainDescription()}}">
        </share-button>
      </div>
    </div>
  </div>
</div>
